import { createContext as o } from "../../external/preact/dist/preact.module.js";
import t from "../Localization/Localization.js";
import { noop as n } from "../../utils/common.js";
const i = o({
  i18n: new t().i18n,
  loadingContext: "",
  commonProps: {},
  updateCore: n,
  componentRef: { current: null }
});
export {
  i as CoreContext
};
